import { render, staticRenderFns } from "./MatchInfo.vue?vue&type=template&id=21cfdaf8&scoped=true&"
import script from "./MatchInfo.vue?vue&type=script&lang=js&"
export * from "./MatchInfo.vue?vue&type=script&lang=js&"
import style0 from "./MatchInfo.vue?vue&type=style&index=0&id=21cfdaf8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21cfdaf8",
  null
  
)

export default component.exports